import React, { useState } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import './XYPlane.css'; 

import { VocabDentistry } from '../../ConfigFiles/multilingual/VocabDentistry';
import {colorsDentistry} from '../../ConfigFiles/colors_dentistry';


//  Ringed quadrant component (SVG Path)
const Quadrant = ({ pathData, isSelected, onSelect, tooltip }) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
    <path
      d={pathData}
      fill={isSelected ? colorsDentistry.selected_color : colorsDentistry.default_color}
      stroke={colorsDentistry.stroke_color}
      strokeWidth="1"
      onClick={onSelect}
      style={{ cursor: 'pointer' }}
    />
  </OverlayTrigger>
);

//  Square component
const Square = ({ x, y, size, isSelected, onSelect, tooltip }) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
    <rect
      x={x}
      y={y}
      width={size}
      height={size}
      fill={isSelected ? colorsDentistry.selected_color : colorsDentistry.default_color}
      stroke={colorsDentistry.stroke_color}
      strokeWidth="1"
      onClick={onSelect}
      style={{ cursor: 'pointer' }}
    />
  </OverlayTrigger>
);

//  Circle component.
const Dot = ({ cx, cy, isSelected, onSelect, tooltip }) => (
  <OverlayTrigger placement="top" overlay={<Tooltip>{tooltip}</Tooltip>}>
    <circle
      cx={cx}
      cy={cy}
      r={10}
      fill={isSelected ? colorsDentistry.selected_color : colorsDentistry.default_color}
      stroke={colorsDentistry.stroke_color}
      strokeWidth="1"
      onClick={onSelect}
      style={{ cursor: 'pointer' }}
    />
  </OverlayTrigger>
);

//  Tooth Object (Circle (oclusal) + Quadrants + Square (Root) + Dot (Whole tooth).
const ObjectComponent = ({ objectId, objectIndex, quadrants, isRootSelected, isOclusalSelected, isToothSelected, onSelectQuadrant, onSelectRoot, onSelectedOclusal, onSelectTooth, lan }) => {
  
  //  SVG Path Data for 4 Ring Segments.
  const quadrantPaths = [
    /*
      M (Move To): Moves the drawing cursor to a new point (without drawing anything).
      A (Arc): Draws an elliptical or circular arc. It takes several arguments:
        The first two numbers are the radii of the arc in the x and y directions.
        The next number (0 in these examples) indicates the angle of rotation of the arc.
        The next two numbers specify whether the arc should be drawn as a large or small arc and whether it should be drawn clockwise or counterclockwise.
        The last pair is the endpoint of the arc.
      L (Line To): Draws a straight line to the specified point.
      Z: Closes the path by drawing a line back to the starting point.
    */
    // Top-left to top-right quadrant.
    'M78,78 A30,30 0 0,1 122,78 L112,88 A20,20 0 0,0 88,88 Z',
    // Top-right to bottom-right quadrant.
    'M122,78 A30,30 0 0,1 122,122 L112,112 A20,20 0 0,0 112,88 Z',
    // Bottom-right to bottom-left quadrant.
    'M122,122 A30,30 0 0,1 78,122 L88,112 A20,20 0 0,0 112,112 Z',
    // Bottom-left to top-left quadrant.
    'M78,122 A30,30 0 0,1 78,78 L88,88 A20,20 0 0,0 88,112 Z',
  ];

  //  Mainly for tooltip.
  const tooth_name = VocabDentistry.tooth[lan] + ' ' +  objectId
  //  For determinint correct tooltip names.
  const firstDigit = objectId.charAt(0);
  const secondDigit = objectId.charAt(1);
  //  Determine oclusal vs. incisal based.
  const oclusalIncisal = ['1', '2', '3'].includes(secondDigit) ? VocabDentistry.incisal[lan] : VocabDentistry.oclusal[lan];
  //  Determine lingual vs. vestibular based on the first digit.
  const lingualVestibular = ['1', '2'].includes(firstDigit) ? VocabDentistry.vestibular[lan] : VocabDentistry.lingual[lan];
  //  Determine vestibular vs. palatino based on the first digit.
  const vestibularPalatino = ['1', '2'].includes(firstDigit) ? VocabDentistry.palatine[lan] : VocabDentistry.vestibular[lan];
  //  Determine Left Quadrant mesial vs distal.
  const leftQuadrant = ['1', '3'].includes(firstDigit) ? VocabDentistry.distal[lan] : VocabDentistry.mesial[lan];
  //  Determine Right Quadrant distal vs mesial.
  const rightQuadrant = ['2', '4'].includes(firstDigit) ? VocabDentistry.distal[lan] : VocabDentistry.mesial[lan];
    //  Names of the faces.
    const quadrant_names = 
    [
      lingualVestibular,
      rightQuadrant, 
      vestibularPalatino,
      leftQuadrant,
    ]

  return (
    <svg width="100" height="120" viewBox="40 0 100 100" className="object-container">
      {/* Top Dot representing the whole object */}
      <Dot
        cx={100}
        cy={15}
        isSelected={isToothSelected}
        tooltip={`${tooth_name}`}
        onSelect={() => onSelectTooth(objectIndex)}
      />

      {/* Top square  */}
      <Square
        x={90}
        y={40}
        size={20}
        isSelected={isRootSelected}
        tooltip={`${tooth_name}: ${VocabDentistry.root[lan]}`}
        onSelect={() => onSelectRoot(objectIndex)}
      />
      
      {/* Middle section */}
      <Dot
        cx={100}
        cy={100}
        isSelected={isOclusalSelected}
        tooltip={`${tooth_name}: ${oclusalIncisal}`}
        onSelect={() => onSelectedOclusal(objectIndex)}
      />

      {/* Quadrants segments  */}
      {quadrants.map((selected, index) => (
        <Quadrant
          key={index}
          pathData={quadrantPaths[index]}
          isSelected={selected}
          tooltip={`${tooth_name}: ${quadrant_names[index]}`}
          onSelect={() => onSelectQuadrant(objectIndex, index)}
        />
      ))}
    </svg>
  );
};

//  Intended to display one quadrant of the mouth.
const MouthQuadrant = ({selectedObjects, parentHandleSelectQuadrant, parentHandleSelectRoot, parentHandleSelectOclusal, parentHandleSelectTooth, quadrant_number, lan,}) => {
  // State to store selected quadrants for each object, all false by default.
  //const [selectedObjects, setSelectedObjects] = useState(passedSelectedObjects)

  
  //  Handle selection of quadrants
   const handleSelectQuadrant = (objectIndex, quadrantIndex) => {
    parentHandleSelectQuadrant(objectIndex, quadrantIndex, quadrant_number)
  };
  //  Handle selection of Root
  const handleSelectRoot = (objectIndex) => {
    parentHandleSelectRoot(objectIndex, quadrant_number)
  };

    //  Handle selection of dot (Oclusal).
    const handleSelectOclusal = (objectIndex) => {
      parentHandleSelectOclusal(objectIndex, quadrant_number)
    };

  //  Handle selection of whole Tooth.
  const handleSelectTooth = (objectIndex) => {
    parentHandleSelectTooth(objectIndex, quadrant_number)
  };

  return (
    <div className="xy-plane">
      {selectedObjects.map((object, index) => (
        <ObjectComponent
          key={object.obj_id}
          objectId={object.obj_id.split('_')[1]}
          objectIndex={index}
          quadrants={selectedObjects[index].quadrants}
          isRootSelected={selectedObjects[index].root}
          isOclusalSelected={selectedObjects[index].oclusal}
          isToothSelected={selectedObjects[index].tooth}
          onSelectQuadrant={handleSelectQuadrant}
          onSelectRoot={handleSelectRoot}
          onSelectTooth={handleSelectTooth}
          onSelectedOclusal={handleSelectOclusal}
          lan={lan}
        />
      ))}
    </div>
  );
};

export default MouthQuadrant;
